module.exports = __webpack_public_path__ + "static/media/panel_user.9871c165.svg";